import AppConstants from 'constants/AppConstants';

export function setColorTheme(
  backgroundBase: string,
  brandMuted: string,
  brandPrimary: string
): BaseTockAction {
  return {
    type: AppConstants.SET_COLOR_THEME,
    payload: {
      backgroundBase,
      brandMuted,
      brandPrimary,
    },
  };
}

export function setFontTheme(font: string): BaseTockAction {
  return {
    type: AppConstants.SET_FONT_THEME,
    payload: {
      font,
    },
  };
}
